import { useEffect, useRef } from 'react';
import { withTranslation } from 'react-i18next';
import './i18n';

const LanguageInit = ({ i18n }) => {
  const initialized = useRef(false);

  useEffect(() => {
    if (initialized.current) return;
    initialized.current = true;

    let language = localStorage.getItem('i18nextLng');

    if (language !== 'es' && language !== 'en') {
      localStorage.setItem('i18nextLng', 'es');
      language = 'es';
    }

    if (language !== i18n.language) {
      i18n.changeLanguage(language);
    }
  }, [i18n]);

  return null;
};

export default withTranslation()(LanguageInit);
